import { Component, Input } from '@angular/core';
import { ImportJobStatus } from '../attr-mapping.constants';

@Component({
  selector: 'vrm-import-job-status',
  templateUrl: './import-job-status.component.html',
  styleUrls: ['./import-job-status.component.scss'],
})
export class ImportJobStatusComponent {
  @Input() jobStatus!: string;
  jobSteps: string[] = ['File Upload', 'Data Validation', 'Approval Review', 'Final Processing', 'Completed'];
  private backendToUiStatus: Record<string, { step: string; class: string }> = ImportJobStatus;
  constructor() {}

  getCompletedStepIndex(): number {
    return this.jobSteps.indexOf(this.getMappedStep().step);
  }

  getMappedStep(): { step: string; class: string } {
    return this.backendToUiStatus[this.jobStatus] || { step: 'Processing', class: 'gray' };
  }

  getIconClass(step: string, index: number): string {
    const completedIndex = this.getCompletedStepIndex();
    if (index < completedIndex) {
      return 'fa fa-check-circle';
    }
    if (index === completedIndex) {
      return this.getMappedStep().class === 'red' ? 'fa fa-times-circle' : 'fa fa-check-circle';
    }
    return 'fas fa-circle';
  }

  getColorClass(index: number): string {
    const completedIndex = this.getCompletedStepIndex();
    if (index < completedIndex) return 'green';
    if (index === completedIndex) return this.getMappedStep().class;
    return 'gray';
  }

  getAnimationClass(index: number): string {
    const completedIndex = this.getCompletedStepIndex();
    if (index === completedIndex && this.getMappedStep().class === 'yellow') {
      return 'pulse';
    }
    return '';
  }
}
